import { render, staticRenderFns } from "./caseStudyPage.vue?vue&type=template&id=4f6ea1ad&scoped=true&"
import script from "./caseStudyPage.vue?vue&type=script&lang=js&"
export * from "./caseStudyPage.vue?vue&type=script&lang=js&"
import style0 from "./caseStudyPage.vue?vue&type=style&index=0&id=4f6ea1ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ea1ad",
  null
  
)

export default component.exports